import ConferenceRepository from './conference.repository';
import FilesRepository from './files.repository';
import UsersRepository from './users.repository';
import NotesRepository from "./notes.repository"
import DashboardRepository from "./dashboard.repository";
import IntegrationRepository from "./integration.repository";
import OperatorsRepository from "./operators.repository";
import NomenclatureRepository from "./nomenclature.repository";
import ReportRepository from "./reports.repository";
import OnlineUserRrpository from "./onlineUsers.repository";
import VideRecordRepository from "./videoRecord.repository";

export const RepositoryFactory = {
    conference: ConferenceRepository,
    files: FilesRepository,
    users: UsersRepository,
    notes: NotesRepository,
    dashboard: DashboardRepository,
    integration: IntegrationRepository,
    operators: OperatorsRepository,
    onlineUser: OnlineUserRrpository,
    nomenclature: NomenclatureRepository,
    reports: ReportRepository,
    record: VideRecordRepository
}
